import styled from '@emotion/styled'

export const BrowserNotificationStyled = styled.div`
  label: BrowserNotificationStyled;
  .alert {
    margin-bottom: 0;
    @media screen and (min-width: ${(props) => props.theme.mq.md}) {
      margin-bottom: 1em;
    }
    button {
      opacity: 100;
    }
  }
`
